import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getAtmDetails = createAsyncThunk("api/atm-payroll/atmDetails", async (token) => {
    try {
        const response = await nodeinstance.get("/atm-payroll/atmDetails", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const AtmDetailsSlice = createSlice({
    name: "atm",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAtmDetails.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getAtmDetails.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAtmDetails.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getAtmDetails };
export default AtmDetailsSlice.reducer;
